import React, { memo } from 'react';
import { useAppTranslation } from '@hooks';
import { PresetTag } from '@components/display';
import { TaskType } from '@pages/types';
import { Collapse, Icon } from 'common-components';

import { DataLabel, DataRow, DataValue, HistoryRow, PanelContainer } from './SidebarRows';

import { store } from '@/store';

type TaskSidebarTaskPropsType = {
  task: TaskType
};

const TaskSidebarTaskComponent = ({ task }: TaskSidebarTaskPropsType) => {
  const { translate } = useAppTranslation();

  const taskLogs = store.use.taskLogs();

  return (
    <Collapse
      bordered={false}
      expandIconPlacement={'end'}
      expandIcon={({ isActive }) => (
        <Icon icon={isActive ? 'ChevronDown' : 'ChevronRight'} size={24} />
      )}
      defaultActiveKey={['']}
      collapsible={'header'}
      items={[
        {
          key: 'metrics',
          label: translate('project.tasklineOverview.sidebar.taskMetrics.title'),
          style: { paddingBottom: 10 },
          children: (
            <PanelContainer>
              {/*idTask*/}
              <DataRow>
                <DataLabel>{translate('project.tasklineOverview.sidebar.taskMetrics.taskId')}</DataLabel>
                <DataValue>{task.idTask}</DataValue>
              </DataRow>
              {/*taskState*/}
              <DataRow>
                <DataLabel>{translate('project.tasklineOverview.sidebar.taskMetrics.status')}</DataLabel>
                <PresetTag preset={'task-state'} style={{ margin: 0 }} state={task?.taskState} withDot>
                  {translate(`common.states.taskState.${task?.taskState}`)}
                </PresetTag>
              </DataRow>
              {/*duration*/}
              <DataRow>
                <DataLabel>{translate('project.tasklineOverview.sidebar.taskMetrics.durationTotal')}</DataLabel>
                <DataValue>{task?.duration ?? '-'}</DataValue>
              </DataRow>
              {/*effectiveTime*/}
              <DataRow>
                <DataLabel>{translate('project.tasklineOverview.sidebar.taskMetrics.effectiveTime')}</DataLabel>
                <DataValue>{task?.effectiveTime ?? '-'}</DataValue>
              </DataRow>
              {/*dueDate*/}
              <DataRow>
                <DataLabel>{translate('project.tasklineOverview.sidebar.taskMetrics.deadlineDate')}</DataLabel>
                <DataValue>{task?.dueDate ?? '-'}</DataValue>
              </DataRow>
              {/*deleveringDate*/}
              <DataRow>
                <DataLabel>{translate('project.tasklineOverview.sidebar.taskMetrics.deliveryDate')}</DataLabel>
                <DataValue>{task?.deleveringDate ?? '-'}</DataValue>
              </DataRow>
              {/*creationDate*/}
              <DataRow>
                <DataLabel>{translate('project.tasklineOverview.sidebar.taskMetrics.creationDate')}</DataLabel>
                <DataValue>{task?.creationDate ?? '-'}</DataValue>
              </DataRow>
            </PanelContainer>
          ),
        },
        {
          key: 'history',
          label: translate('project.tasklineOverview.sidebar.history.title'),
          style: { paddingTop: 10 },
          children: (
            <PanelContainer>
              {taskLogs.map((log, i: number) => (
                <HistoryRow
                  key={`${log.creationDate}-${log.event}-${i}`}
                  date={log.creationDate}
                  event={translate(`common.states.eventType.${log.event}`)}
                  user={log.user}
                />
              ))}
            </PanelContainer>
          ),
        },
      ]}
    />
  );
};

const TaskSidebarTask = memo(
  TaskSidebarTaskComponent,
  (oldProps: TaskSidebarTaskPropsType, newProps: TaskSidebarTaskPropsType) => {
    return JSON.stringify(oldProps) === JSON.stringify(newProps);
  },
);

export default TaskSidebarTask;
